import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../../components/CandelOrder/cancelOrder.css";

const SuccessScreen = ({ showName, externalPlatform, title, subtitle }) => {
  const { t } = useTranslation();
  const reduxShowName = useSelector((state) => state.reservation?.showName);

  const venueName = showName || reduxShowName || "";
  const finalTitle = title || t("modifyReservationEdit.successTitle");
  const finalSubtitle =
    subtitle ||
    (venueName
      ? t("modifyReservationEdit.successSubtitleNamed", { venue: venueName })
      : t("modifyReservationEdit.successSubtitle"));
  const showExternalPlatform =
    externalPlatform?.showPowerBy && externalPlatform?.name;

  return (
    <div className="co">
      {venueName && (
        <header className="co__header">
          <span className="co__brand">{venueName}</span>
        </header>
      )}

      <main className="co__main">
        <div className="co__container">
          <div className="co__state">
            <div className="co__status-icon co__status-icon--success">
              <svg viewBox="0 0 24 24">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <div className="co__eyebrow co__eyebrow--success">
              <span className="co__eyebrow-rule" />
              <span className="co__eyebrow-diamond">◆</span>
              <span className="co__eyebrow-text">
                {t("modifyReservationEdit.successEyebrow")}
              </span>
              <span className="co__eyebrow-diamond">◆</span>
              <span className="co__eyebrow-rule" />
            </div>
            <h1 className="co__title">{finalTitle}</h1>
            <p className="co__subtitle">{finalSubtitle}</p>
          </div>
        </div>
      </main>

      <footer className="co__footer">
        <p className="co__footer-powered">
          Powered by Wellet
          {showExternalPlatform ? ` · ${externalPlatform.name}` : ""}
        </p>
      </footer>
    </div>
  );
};

export default SuccessScreen;
